/* @flow */
import * as React from 'react';

const CreditCardMastercard = props => (
  <svg focusable="false" viewBox="0 0 32 21" fillRule="evenodd" {...props}>
    <path
      fill="#003663"
      d="M26.58,21 H2.42 A2.4,2.4 0 0 1 0,18.62 V4.38 A2.4,2.4 0 0 1 2.42,2 h24.16 A2.4,2.4 0 0 1 29,4.38 v14.25 A2.4,2.4 0 0 1 26.58,21 Z"
    />
    <circle fill="#EB1C26" cx={10.5} cy={11.5} r={6.5} />
    <circle fill="#F99F1B" cx={18.5} cy={11.5} r={6.5} />
    <path fill="#EF5D20" d="M14.5,6.38 a6.49,6.49 0 0 0 0,10.24 a6.49,6.49 0 0 0 0,-10.24 Z" />
  </svg>
);

export default CreditCardMastercard;



// WEBPACK FOOTER //
// ./src/assets/images/icons/credit-card-mastercard.js